// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thread-wrapper[data-v-463084f6] {
  display: flex;
  transition: all 0.25s;
  border-top: 1px solid var(--comments-border-top);
  height: 2.6rem;
  padding-top: 16px;
  margin-top: 4px;
  cursor: pointer;
  width: 104%;
  margin-left: -4px;
  margin-bottom: -4px;
  padding-bottom: 1.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  min-width: 19.2rem;
  color: var(--comments-color);
}
.thread-wrapper[data-v-463084f6]:hover,
.thread-wrapper.isActive[data-v-463084f6] {
  background-color: var(--bg-comments-hover-right);
}
.thread-wrapper.leftSide[data-v-463084f6]:hover,
.thread-wrapper.leftSide.isActive[data-v-463084f6] {
  background-color: var(--bg-comments-hover-left);
}
.thread-wrapper .thread-content[data-v-463084f6] {
  display: flex;
  width: 97%;
  align-items: center;
  justify-content: space-between;
}
.thread-wrapper .thread-content .thread-section-left[data-v-463084f6] {
  display: flex;
  height: 1.6em;
  align-items: baseline;
}
.thread-wrapper .thread-content .thread-section-left .thread-icon-left[data-v-463084f6] {
  display: flex;
  align-self: center;
}
.thread-wrapper .thread-content .thread-section-left .thread-icon-left i[data-v-463084f6] {
  font-size: 1.7rem;
}
.thread-wrapper .thread-content .thread-section-left .thread-info[data-v-463084f6] {
  display: flex;
  transition: all 0.25s;
  font-size: 0.85em;
  font-weight: 600;
  align-self: center;
  margin: 0 0.35rem;
}
.thread-wrapper .thread-content .thread-section-left .thread-count[data-v-463084f6] {
  margin: 0 0.35rem;
}
.thread-wrapper .thread-content .thread-section-left .thread-read[data-v-463084f6] {
  margin-left: 0.35em;
  margin-top: -1px;
}
.thread-wrapper .thread-content .thread-section-left .thread-read i[data-v-463084f6] {
  font-size: 0.7em;
}
.thread-wrapper .thread-content .thread-section-right[data-v-463084f6] {
  position: relative;
  display: flex;
  justify-content: center;
}
.thread-wrapper .thread-content .thread-section-right .thread-icon-right i[data-v-463084f6] {
  font-weight: 300;
  font-size: 1.5rem;
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/chat/ChatThreads.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;EACrB,gDAAgD;EAChD,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;;EAEE,gDAAgD;AAClD;AACA;;EAEE,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd","sourcesContent":[".thread-wrapper[data-v-463084f6] {\n  display: flex;\n  transition: all 0.25s;\n  border-top: 1px solid var(--comments-border-top);\n  height: 2.6rem;\n  padding-top: 16px;\n  margin-top: 4px;\n  cursor: pointer;\n  width: 104%;\n  margin-left: -4px;\n  margin-bottom: -4px;\n  padding-bottom: 1.5rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  min-width: 19.2rem;\n  color: var(--comments-color);\n}\n.thread-wrapper[data-v-463084f6]:hover,\n.thread-wrapper.isActive[data-v-463084f6] {\n  background-color: var(--bg-comments-hover-right);\n}\n.thread-wrapper.leftSide[data-v-463084f6]:hover,\n.thread-wrapper.leftSide.isActive[data-v-463084f6] {\n  background-color: var(--bg-comments-hover-left);\n}\n.thread-wrapper .thread-content[data-v-463084f6] {\n  display: flex;\n  width: 97%;\n  align-items: center;\n  justify-content: space-between;\n}\n.thread-wrapper .thread-content .thread-section-left[data-v-463084f6] {\n  display: flex;\n  height: 1.6em;\n  align-items: baseline;\n}\n.thread-wrapper .thread-content .thread-section-left .thread-icon-left[data-v-463084f6] {\n  display: flex;\n  align-self: center;\n}\n.thread-wrapper .thread-content .thread-section-left .thread-icon-left i[data-v-463084f6] {\n  font-size: 1.7rem;\n}\n.thread-wrapper .thread-content .thread-section-left .thread-info[data-v-463084f6] {\n  display: flex;\n  transition: all 0.25s;\n  font-size: 0.85em;\n  font-weight: 600;\n  align-self: center;\n  margin: 0 0.35rem;\n}\n.thread-wrapper .thread-content .thread-section-left .thread-count[data-v-463084f6] {\n  margin: 0 0.35rem;\n}\n.thread-wrapper .thread-content .thread-section-left .thread-read[data-v-463084f6] {\n  margin-left: 0.35em;\n  margin-top: -1px;\n}\n.thread-wrapper .thread-content .thread-section-left .thread-read i[data-v-463084f6] {\n  font-size: 0.7em;\n}\n.thread-wrapper .thread-content .thread-section-right[data-v-463084f6] {\n  position: relative;\n  display: flex;\n  justify-content: center;\n}\n.thread-wrapper .thread-content .thread-section-right .thread-icon-right i[data-v-463084f6] {\n  font-weight: 300;\n  font-size: 1.5rem;\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
